export const BOOKING_TYPE = {
  DAY: "Day",
  NIGHT: "Night",
};

export const BOOKING_LOCATIONS = [
  {
    id: "1e8a7f8f-c6ea-4d9f-afa9-613968be3c10",
    name: "Harbor Base",
    subtitle: "Central launch near the city harbor",
    coords: [48.2065, 16.3706],
  },
  {
    id: "3fb6f8ce-0c75-41f3-8f38-5f0f0a2b1c7e",
    name: "Lakeside Retreat",
    subtitle: "Calm waters and plenty of space to explore",
    coords: [48.2408, 16.4462],
  },
  {
    id: "7d2a97fa-8d2b-4e61-9c5f-6e12c6ef2e4d",
    name: "Riverfront Launch",
    subtitle: "Meetups and guided tours depart here",
    coords: [48.2301, 16.4112],
  },
];

export const EQUIPMENT_TYPE_IDS = {
  soloSup: "4a1d4f5e-b3c7-4d3f-8a4c-54f5cc3d2c8e",
  bigSup: "53dbef07-e0d7-40f1-95d6-4a4a7a3f2e2b",
  glowingSup: "e9d23ea4-5f3c-4f1b-bb2b-9adf5b1f4d7c",
  soloKayak: "9f03a1a6-8e3c-4f79-9f24-4c1c7eb2fd55",
  bigKayak: "b4c5d9f0-7b0e-4d5e-ae9a-13a8c3f8409e",
  utilities: "c8d96baf-5fd8-4a29-8b5f-0a8d8f0e2a6f",
};

export const EQUIPMENT_KEY_TO_ID = {
  sup: EQUIPMENT_TYPE_IDS.soloSup,
  big_sup: EQUIPMENT_TYPE_IDS.bigSup,
  kayak: EQUIPMENT_TYPE_IDS.soloKayak,
  big_kayak: EQUIPMENT_TYPE_IDS.bigKayak,
  kit: EQUIPMENT_TYPE_IDS.utilities,
  neon_board: EQUIPMENT_TYPE_IDS.glowingSup,
};

export const DAY_EQUIPMENT_KEYS = ["sup", "big_sup", "kayak", "big_kayak", "neon_board", "kit"];
export const NIGHT_EQUIPMENT_KEYS = ["neon_board", "kit"];

export const buildItemsPayload = (items, equipmentKeys) =>
  equipmentKeys
    .map((key) => {
      const quantity = items[key];
      const equipmentTypeId = EQUIPMENT_KEY_TO_ID[key];

      if (!equipmentTypeId || !quantity) {
        return null;
      }

      return { equipmentTypeId, quantity };
    })
    .filter(Boolean);
